import { QueryClient } from '@tanstack/react-query';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

export const persister =
  typeof window !== 'undefined'
    ? createSyncStoragePersister({
        storage: window.sessionStorage,
        key: 'vpnf-rq-cache',
        throttleTime: 3000,
      })
    : undefined;
